import React from 'react';

import { dataHooks } from '../../constants';
import {
  FieldSetProps,
  LegendPlacement,
  LegendSize,
} from '../../FieldSet.types';

import { st, classes } from './InlineLabelWrapper.st.css';

type Props = Pick<FieldSetProps, 'children' | 'charCount' | 'suffix'> & {
  labelPlacement: LegendPlacement;
  labelSize: LegendSize;
};

const InlineLabelWrapper = ({
  children,
  suffix,
  charCount,
  labelPlacement,
  labelSize,
}: Props) => (
  <div
    data-hook={dataHooks.labelIndicators}
    className={st(classes.root, {
      inlineWithSuffix: Boolean(suffix || charCount !== undefined),
      labelPlacement,
      labelSize,
    })}
  >
    {children}
  </div>
);

export { InlineLabelWrapper };
